let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3MwXk")).then(() => parcelRequire('aoDXB'));